// Currency chart
export const pieChartColors = [];
setTimeout(() => {
    getColorPalettes('currency').forEach(color => pieChartColors.push(color));
    pieChartColors.push("#FFFFFF"); // TODO: sum of 'other' currencies
})

// Mapping asset class with css colors variable
const assetColors = {
    cash: 'cash',
    loans: 'loan',
    realEstate: 'real',
    publicFundsSecurities: 'public',
    privateFunds: 'private',
    pensionFunds: 'retire',
    privateSecurities: 'private',
    preciousMetals: 'metal',
    jewelleryNWatches: 'luxury',
    cryptocurrencies: 'crypto',
    other: 'other',
};

export function getCssColor(variable) {
    return getComputedStyle(document.documentElement)
        .getPropertyValue(`--${variable}`)
        .trim();
}

function getColorPalettes(colorName) {
    const colors = [];
    for (let i = 4; i >= 1; i--) {
        colors.push(getCssColor(colorName + i));
    }
    return colors;
}

export function initAssetGraphColors(assetClass) {
    // Wait css loaded
    setTimeout(() => {
        const colorName = assetColors[assetClass.value] || 'other';
        assetClass.colorArray = getColorPalettes(colorName);
        assetClass.baseColor = assetClass.colorArray[0];
    });
}

export function getRandomColor() {
    const colors = Object.keys(assetColors);
    return getCssColor(colors[Math.floor(Math.random() * colors.length)] + '4');
}